import { isPublicRoute } from './visibility'

export type ErrorSurface = 'route' | 'pub401' | 'pub403' | 'pubFinished' | 'pub404'

/**
 * which component renders when `pageError` is set. a public magic-link route keeps
 * the designed pub pages, because an expired link must land on the 401/404 a
 * customer is meant to see; on this app's own pages PubPage40x is wrong — it wraps
 * the message in a fake offer page built from DefaultLot()
 */
export function chooseErrorSurface(pathname: string, code?: number): ErrorSurface {
	if (!isPublicRoute(pathname)) return 'route'
	if (code === 401) return 'pub401'
	if (code === 403) return 'pub403'
	if (code === 410) return 'pubFinished'

	return 'pub404'
}
